import { type UseQueryOptions, useQuery } from '@tanstack/react-query'
import { httpGetServiceProPhotos } from '@/features/service-vetting/http/services-vetting.http.ts'
import type { ServiceProPhotos } from '@/features/service-vetting/types.ts'
import { QUERY_KEYS } from '@/query-client'
import { remapServiceForVettingProPhotos } from '../utils'

export const useGetServiceProPhotos = (
	serviceId: number,
	options?: Omit<UseQueryOptions<ServiceProPhotos>, 'queryFn' & 'queryKey'>
) => {
	const query = useQuery({
		...options,
		queryKey: [QUERY_KEYS.SERVICE_PRO_PHOTOS, serviceId],
		queryFn: () =>
			httpGetServiceProPhotos({
				urlParams: { serviceId },
				params: { responseType: 'extended' }
			})
	})

	return {
		...query,
		remappedData: query.data
			? remapServiceForVettingProPhotos(query.data)
			: undefined
	}
}
